import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

const SelectInput = ({ name, label, labelStyle, onChange, defaultOptionText, defaultOptionValue, disabled, value, options, validate, errorMessage, required, errorRequiredMessage, requiredOverZero}) => {
    const wrapperClass = 'input-group input-group-inline';

    if (!options || !Array.isArray(options))
        options = [];

    if (!disabled)
        disabled = false;

    function validation(value) {
        if (validate && !validate(value)) {
            if (errorMessage)
                return errorMessage;
            return 'Validazione non rispettata';
        }
        else if (required && ( (_.isEmpty(value) && !_.isNumber(value) && !_.isBoolean(value)) || (requiredOverZero && _.toInteger(value) < 1) )) {
            if (errorRequiredMessage)
                return errorRequiredMessage;
            return 'Campo obbligatorio';
        }
    }

    const resultErrorMessage = validation(value);

    return (
        <div className='formComponent'>
            <div className={wrapperClass}>
                {label ? <label className='input-group-addon' htmlFor={name} style={labelStyle}>{label}</label> : ''}
                <select
                    disabled={disabled}
                    name={name}
                    value={value}
                    onChange={onChange}
                    className="form-control">
                    {(defaultOptionText || defaultOptionText === '')   ? <option value={defaultOptionValue}>{defaultOptionText}</option> : ''}
                    {options.map((option) => {
                        return (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled ? true : null}
                          >
                            {option.text}
                          </option>
                        );
                    })
                    }
                </select>
            </div>
            {resultErrorMessage !== '' && <div style={{color:'#a94442'}}>{resultErrorMessage}</div>}
        </div>
    );
};

SelectInput.propTypes = {
    defaultOption: PropTypes.string,
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string, // Used for custom validation
    errorRequiredMessage: PropTypes.string, // Used with required
    label: PropTypes.string,
    labelStyle: PropTypes.object,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.object),
    required: PropTypes.bool, // If this field is required
    requiredOverZero: PropTypes.bool, // If this field is required and must be integer over 0
    validate: PropTypes.func
};

export default SelectInput;
